module.exports = __webpack_public_path__ + "static/gallery-mobile-7856b7a142d625a8c7460f8c42ba9802.jpg";